import React, { useEffect, useState } from 'react'
import { getAllAmenityAvailability } from '../services/amenityService';

export const useGetAmenityAvailability = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getAllData = async () => {
        setIsLoading(true);
        try {
            const response = await getAllAmenityAvailability();
            setData(response?.result);
            setIsLoading(false)
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllData()
    },[])

    const refresh = () => {
        getAllData()
    }
    
    return {data, isLoading, error, refresh}
}
